import {paDom} from "./paDom";

export const paDomEl = {
    init() {
        Element.prototype.addClass = this.addClass;
        Element.prototype.removeClass = this.removeClass;
        Element.prototype.nextSiblings = this.nextSiblings;
        Element.prototype.prevSiblings = this.prevSiblings;
        Element.prototype.siblings = this.siblings;
        Element.prototype.parent = this.parent;
        Element.prototype.on = this.on;
        Element.prototype.click = this.click;
        Element.prototype.delegate = this.delegate;
        Element.prototype.hover = this.hover;
    },
    addClass(classToAdd) {
        this.classList.add(classToAdd);
        return this;
    },
    removeClass(classToRemove) {
        this.classList.remove(classToRemove);
        return this;
    },
    prevSiblings() {
        let siblings = [], n = this;
        while (n = n.previousElementSibling) siblings.push(n);
        return siblings;
    },
    nextSiblings() {
        let siblings = [], n = this;
        while (n = n.nextElementSibling) siblings.push(n);
        return siblings;
    },
    siblings() {
        let prev = this.prevSiblings() || [],
            next = this.nextSiblings() || [];
        return paDom.nodeListFromArray(prev.concat(next));
    },
    parent(selector) {
        if (typeof selector == 'undefined') {
            return paDom.get(this.parentElement)
        } else {
            return paDom.get(this.closest(selector))
        }
    },
    on(event, callback) {
        paDom.bind(this, callback, event);
        return this;
    },
    click(callback) {
        paDom.bind(this, callback);
        return this;
    },
    delegate(event, target, callback) {
        paDom.delegate(event, this, target, callback)
        return this;
    },
    hover(inCallback, outCallback) {
        paDom.bind(this, inCallback, 'mouseenter');
        paDom.bind(this, outCallback, 'mouseleave');
        return this;
    }
};



// WEBPACK FOOTER //
// ./src/js/framework/paDomEl.js